<template>
    <div class="t-locale">
        <div
            v-if="isMobile && !$route.path.includes('/lk')"
            class="t-locale-country js-region"
            :class="{_lk: $route.path.includes('/lk')}"
        >
            <select class="t-locale__select" @change="SetRegion($event.target.value)">
                <option
                    v-for="item in locale"
                    :key="'region_' + item.id"
                    :selected="item.id === region.defaultValue || item.current"
                    :value="item.id"
                >
                    {{ item.name }}
                </option>
            </select>
            <svg
                v-if="$route.path.includes('/lk')"
                :class="{ _active: open === 2 }" class="t-locale__svg"
                width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
            >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.69526 9.02876C3.95561 8.76841 4.37772 8.76841 4.63807 9.02876L10 14.3907L15.3619 9.02876C15.6223 8.76841 16.0444 8.76841 16.3047 9.02876C16.5651 9.28911 16.5651 9.71122 16.3047 9.97157L10.4714 15.8049C10.2111 16.0653 9.78895 16.0653 9.5286 15.8049L3.69526 9.97157C3.43491 9.71122 3.43491 9.28911 3.69526 9.02876Z" fill="white"/>
            </svg>
            <svg v-else class="t-locale__svg" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L4.76471 6L9 1" stroke="white"/>
            </svg>
        </div>

        <div
            v-else-if="!$route.path.includes('/lk')"
            class="t-locale-country js-region"
            :class="{_lk: $route.path.includes('/lk')}"
        >
            <div class="t-locale__active" :class="{_cursor: locale.length <= 1}" @click="OpenLinks(1)">
                <span
                    class="t-locale__active-text"
                    v-for="item in locale"
                    v-if="item.id === region.defaultValue || item.current"
                >
                    {{ item.name }}
                </span>
                <svg
                    v-if="$route.path.includes('/lk') && locale.length > 1"
                    :class="{ _active: open === 1 }" class="t-locale__svg"
                    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.69526 9.02876C3.95561 8.76841 4.37772 8.76841 4.63807 9.02876L10 14.3907L15.3619 9.02876C15.6223 8.76841 16.0444 8.76841 16.3047 9.02876C16.5651 9.28911 16.5651 9.71122 16.3047 9.97157L10.4714 15.8049C10.2111 16.0653 9.78895 16.0653 9.5286 15.8049L3.69526 9.97157C3.43491 9.71122 3.43491 9.28911 3.69526 9.02876Z" fill="white"/>
                </svg>
                <svg
                    v-else-if="locale.length > 1"
                    :class="{ _active: open === 1 }" class="t-locale__svg"
                    width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.71232 3.62758L0 0.841101L0.575369 0.25L3 2.74093L5.42463 0.25L6 0.841101L3.28768 3.62758C3.1288 3.79081 2.8712 3.79081 2.71232 3.62758Z" fill="#929292"/>
                </svg>
            </div>
            <transition name="fade">
                <div class="t-locale__links" v-if="open === 1 && locale.length > 1" @click="OpenLinks(0)">
                    <template v-for="item in locale">
                        <div
                            class="t-locale__link"
                            :key="'region_' + item.id"
                            v-if="item.id !== region.defaultValue && !item.current"
                            @click="SetRegion(item)"
                        >
                            {{ item.name }}
                        </div>
                    </template>
                </div>
            </transition>
        </div>

        <div v-if="isMobile" class="t-locale__lang js-locale" :class="{_lk: $route.path.includes('/lk')}">
            <!-- <img
                v-if="locale.filter(item => item.value === $router.history.base)[0].img && $route.path.includes('/lk')"
                class="t-locale__flag"
                :src="locale.filter(item => item.value === $router.history.base)[0].img"
                :alt="locale.filter(item => item.value === $router.history.base)[0].label"
            > -->
            <select class="t-locale__select" @change="SetLocale($event.target.value)">
                <option
                    v-for="item in languagesAvailable"
                    :key="'locale_' + item.value"
                    :selected="item.current || defaultLocale.value === item.value"
                    :value="item.value"
                >
                    {{ item.label }}
                </option>
            </select>
            <svg
                v-if="$route.path.includes('/lk')"
                :class="{ _active: open === 2 }" class="t-locale__svg"
                width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
            >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.69526 9.02876C3.95561 8.76841 4.37772 8.76841 4.63807 9.02876L10 14.3907L15.3619 9.02876C15.6223 8.76841 16.0444 8.76841 16.3047 9.02876C16.5651 9.28911 16.5651 9.71122 16.3047 9.97157L10.4714 15.8049C10.2111 16.0653 9.78895 16.0653 9.5286 15.8049L3.69526 9.97157C3.43491 9.71122 3.43491 9.28911 3.69526 9.02876Z" fill="white"/>
            </svg>
            <svg v-else class="t-locale__svg" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L4.76471 6L9 1" stroke="white"/>
            </svg>
        </div>

        <div v-else class="t-locale__lang js-locale" :class="{_lk: $route.path.includes('/lk')}">
            <div class="t-locale__active" :class="{_cursor: locale.length <= 1}" @click="OpenLinks(2)">
                <span
                    class="t-locale__active-text"
                    v-for="item in languagesAvailable"
                    v-if="item.current || $router.history.base === item.value || $router.history.base === '/' + item.value"
                >
                    <img class="t-locale__flag" v-if="item.img" :src="item.img" :alt="item.label">
                    {{ item.label }} 
                </span>
                <svg
                    v-if="$route.path.includes('/lk') && languagesAvailable.length > 1"
                    :class="{ _active: open === 2 }" class="t-locale__svg"
                    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.69526 9.02876C3.95561 8.76841 4.37772 8.76841 4.63807 9.02876L10 14.3907L15.3619 9.02876C15.6223 8.76841 16.0444 8.76841 16.3047 9.02876C16.5651 9.28911 16.5651 9.71122 16.3047 9.97157L10.4714 15.8049C10.2111 16.0653 9.78895 16.0653 9.5286 15.8049L3.69526 9.97157C3.43491 9.71122 3.43491 9.28911 3.69526 9.02876Z" fill="white"/>
                </svg>
                <svg
                    v-else-if="languagesAvailable.length > 1"
                    :class="{ _active: open === 2 }" class="t-locale__svg"
                    width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.71232 3.62758L0 0.841101L0.575369 0.25L3 2.74093L5.42463 0.25L6 0.841101L3.28768 3.62758C3.1288 3.79081 2.8712 3.79081 2.71232 3.62758Z" fill="#929292"/>
                </svg>
            </div>
            <transition name="fade">
                <div class="t-locale__links" v-if="open === 2 && languagesAvailable.length > 1" @click="OpenLinks(0)">
                    <template v-for="item in languagesAvailable">
                        <div
                            class="t-locale__link"
                            v-if="!item.current && $router.history.base !== item.value && $router.history.base !== '/' + item.value"
                            :key="'locale_' + item.value"
                            @click.prevent="SetLocale(item.value)"
                        >
                            <img class="t-locale__flag" v-if="item.img" :src="item.img" :alt="item.label">
                            {{ item.label }} 
                        </div>
                    </template>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapState, mapMutations } from 'vuex';

    export default {
        data() {
            return {
                open: 0, // 1 - region, 2 - locale
                defaultLocale: ''
            };
        },
        computed: {
            ...mapGetters('locale', ['locale', 'region', 'languagesAvailable']),
            ...mapState('mobile', ['isMobile']),
        },
        methods: {
            ...mapMutations('locale', ['LoadLanguages']),
				
			SetRegion(item) {
				let localeItem = item;
				if (this.isMobile) {
					this.locale.forEach((i) => {
					if (i.id == item) {
						localeItem = i;
					}
					});
				}
				this.LoadLanguages(localeItem.languagesAvailable);
				for (let i = 0; i < localeItem.languagesAvailable.length; i++) {
					if (
					localeItem.defaultLanguage === localeItem.languagesAvailable[i].id
					) {
					this.defaultLocale = localeItem.languagesAvailable[i];
					} else if (!localeItem.defaultLanguage) {
					this.defaultLocale = localeItem.languagesAvailable[0];
					}
				}

				this.SetLocale(this.defaultLocale.value);
				this.reloadPage();
			},

            SetLocale(e) {
                // this.open = 2;
                this.$cookie.set('locale', e, { expires: '1Y' });

                if (e === '') {
                    this.$router.history.base = '';
                    Vue.http.options.root = '/api';
                } else {
                    this.$router.history.base = '/' + e;
                    Vue.http.options.root = '/api/' + e;
                }
                this.reloadPage();

                // let url = '/api/lang/';
                // Vue.http
                //     .get(url)
                //     .then((response) => response.json())
                //     .then((data) => {
                //         this.$root.staticText = data;
                //     });
            },
            reloadPage() {
                // перезагрузка страницы
                window.location =
                    window.location.protocol +
                    '//' +
                    window.location.host +
                    this.$router.history.base +
                    this.$route.fullPath;
            },
            OpenLinks(number) {
                this.open = (this.open === 1 || this.open === 2) ? 0 : number;
            },
        },
        mounted() {
            let _this = this;

            document.addEventListener('click', function (e) {
                let menuLocale = document.querySelector('.js-locale');
                let menuRegion = document.querySelector('.js-region');

                if (menuLocale !== null || menuRegion !== null) {
                    let itsMenuLocale = e.target === menuLocale || (menuLocale && menuLocale.contains(e.target));
                    let itsMenuRegion = e.target === menuRegion || (menuRegion && menuRegion.contains(e.target));

                    if ((!itsMenuLocale && _this.open === 2) || (!itsMenuRegion && _this.open === 1)) {
                        _this.open = 0;
                    }
                }
            });
                            
            this.LoadLanguages(this.locale.filter(item => item.current)[0].languagesAvailable)
            this.locale.forEach((item) => {
                for(let i = 0; i < this.languagesAvailable.length; i++) {
                    if(item.defaultLanguage === this.languagesAvailable[i].id && item.current) {
                        this.defaultLocale = this.languagesAvailable[i]

                    } else if(!item.defaultLanguage && item.current) {
                        this.defaultLocale = this.languagesAvailable[0]
                    }
                }
            })
            // this.SetLocale(this.defaultLocale.value)
        },
    };
</script>

<style lang="sass">
    @import "~@src/sass/params"

    .t-locale
        display: flex
        align-items: center
        z-index: 1

        &-country
            position: relative
            display: flex
            align-items: center
            .t-locale__active, .t-locale__link
                font-size: 14px
            &._lk
                display: none !important
                .t-locale
                    display: none !important
                    &__active-text
                        color: #ffffff
                    &__svg
                        margin: 0
                        min-width: 20px

        &__lang
            position: relative
            display: flex
            align-items: center
            &._lk
                display: none !important
                .t-locale
                    display: none !important
                    &__active-text
                        color: #ffffff
                    &__svg
                        margin: 0
                        min-width: 20px
                    &__active, &__link
                        font-size: 16px
            & .t-locale__active-text:not(:first-child)
                display: none

        &__select
            outline: none
            font-size: 16px
            line-height: 1.2
            background: transparent
            border: none
            color: #929292
            border-radius: 0
            appearance: none
            margin-right: 4px

        &__active
            padding: 0 8px 2px
            font-size: 12px
            line-height: 19px
            max-width: 120px
            cursor: pointer
            display: flex
            align-items: center

            &-text
                color: $gray-text
                display: flex
                align-items: center
            &._cursor
                cursor: default

        &__links
            padding: 12px
            position: absolute
            top: 100%
            left: 0
            background: #ffffff
            color: $gray-text
            box-shadow: 0 24px 48px rgba(0, 0, 0, 0.1)
            display: flex
            flex-direction: column
            align-items: flex-start
            z-index: 2

        &__link
            background: transparent
            border: none
            font-size: 12px
            line-height: 19px
            outline: none
            cursor: pointer
            display: flex
            align-items: center

            &._active
                display: none

            &:not(:last-child)
                margin-bottom: 12px

        &__flag
            margin-top: 2px
            margin-right: 8px
            width: 14px

        &__svg
            margin-left: 6px
            min-width: 6px
            margin-top: 1px
            transition: all .3s
            &._active
                transform: rotate(180deg)
                -moz-transform: rotate(180deg)
                transform-style: preserve-3d

        @media screen and (min-width: $desktop-medium)
            &-country
                .t-locale__active, .t-locale__link
                    font-size: 16px
            &__active, &__link
                font-size: 14px

        @media screen and (min-width: $desktop-big)
            &-country
                .t-locale__active, .t-locale__link
                    font-size: 18px
            &__active, &__link
                font-size: 16px

        @media screen and (max-width: $mobile-size)
            &-country
                margin-right: 16px
            &__active, &__link
                font-size: 16px
            &__svg
                margin-bottom: 1px
                margin-left: 0
                path
                    stroke: #929292

</style>



// WEBPACK FOOTER //
// src/templates/components/base/locale.vue